import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import i18next from "i18next";
import { EN, VI } from "../common/text";

export const useLanguage = () => {
  const location = useLocation();
  const [language, setLanguage] = useState();
  const params = new URLSearchParams(location.search);
  const lang = params.get("location");

  const localeSession = sessionStorage.getItem("location");

  useEffect(() => {
    if (lang && (lang === VI || lang === EN)) {
      sessionStorage.setItem("location", lang);
      setLanguage(lang);
    } else if (localeSession) {
      setLanguage(localeSession);
    } else {
      sessionStorage.setItem("location", VI);
      setLanguage(VI);
    }
  }, [localeSession, lang]);

  useEffect(() => {
    i18next.changeLanguage(localeSession);
  }, [language]);

  return { language, setLanguage };
};
